import {
  Autocomplete,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { CmpDatePicker } from "../../../Component/Common/ToolBox/ToolBox";

const HeaderComponent = ({
  vMediaQuery,
  handleLoadBtn = () => {},
  status,
  setFilterState = () => {},
  filterState = {},
  vRdxDBLocation = [],
}) => {
  const handleStatusChange = (event) => {
    setFilterState((prev) => ({
      ...prev,
      status: event.target.value,
    }));
  };

  return (
    <div className="stock-detail">
      {/* Filters Section */}
      <Grid
        container
        columnSpacing={{ xs: 1, sm: 1.5, md: 2, lg: 4 }}
        rowSpacing={{ xs: 1.5, sm: 1, md: 2, lg: 2 }}
        marginTop={{ xs: 0.5, sm: 0.5, md: 1, lg: 1 }}
      >
        <Grid item xs={12} sm={3} md={2}>
          <Typography>From Date</Typography>
          <CmpDatePicker
            xValue={filterState?.dateFrom}
            xOnChange={(newValue) =>
              setFilterState((obj) => ({
                ...obj,
                dateFrom: newValue.$d,
              }))
            }
            xName={"dateFrom"}
            xError={false}
            xErrorMessage={false}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2}>
          <Typography>To Date</Typography>
          <CmpDatePicker
            xValue={filterState?.dateTo}
            xOnChange={(newValue) =>
              setFilterState((obj) => ({
                ...obj,
                dateTo: newValue.$d,
              }))
            }
            xName={"dateTo"}
            xError={false}
            xErrorMessage={false}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography>Location</Typography>

          <Autocomplete
            freeSolo
            id="free-solo-2-demo"
            disableClearable
            options={vRdxDBLocation} // Use full objects
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.Name1
            } // Support free text input
            value={
              vRdxDBLocation.find((loc) => loc.Uid === filterState?.location) ||
              null
            }
            onChange={(event, newValue) => {
              if (typeof newValue === "string") {
                setFilterState((prev) => ({
                  ...prev,
                  location: newValue, // Store typed value
                }));
              } else if (newValue) {
                setFilterState((prev) => ({
                  ...prev,
                  location: newValue.Uid, // Store UID when selecting from dropdown
                }));
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                slotProps={{
                  input: {
                    ...params.InputProps,
                    type: "search",
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Typography>Status</Typography>
          <FormControl fullWidth>
            <Select
              value={filterState?.status || ""}
              name="status"
              onChange={handleStatusChange}
            >
              {status.map((sts) => (
                <MenuItem key={sts} value={sts}>
                  {sts}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={2}
          textAlign={vMediaQuery ? "center" : "right"}
        >
          <Button
            variant="contained"
            sx={{
              width: "100px",
              mt: vMediaQuery ? 1 : 2,
              textTransform: "capitalize",
            }}
            onClick={handleLoadBtn}
          >
            Load
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default HeaderComponent;
